import React, { useState } from "react";
import { Checkbox } from "../ui/checkbox";
import { toast } from "sonner";
import { handoverApi } from "./handoverApi";

export const ClientVisibleToggle = ({ defect, onChanged }) => {
  const [busy, setBusy] = useState(false);
  if (defect.walkthrough_id && !defect.added_after_walkthrough) {
    return <p className="text-xs text-indigo-700" data-testid="defect-walkthrough-note">Recorded during a client walkthrough — always shared with the client.</p>;
  }

  const toggle = async (include) => {
    setBusy(true);
    try {
      const r = await handoverApi(`/defects/${defect.id}/client-visible`, { method: "PUT", body: { include } });
      toast.success(include ? `Added to client walkthrough #${r.walkthrough_sequence} (added after walkthrough)` : "Removed from the client's view");
      onChanged({ client_visible: r.client_visible, added_after_walkthrough: include, walkthrough_id: r.walkthrough_id || null });
    } catch (e) {
      toast.error(e.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <label className="flex items-start gap-3 rounded-lg border border-indigo-200 bg-indigo-50/60 p-3 cursor-pointer" data-testid="client-visible-toggle">
      <Checkbox checked={!!defect.client_visible} disabled={busy} onCheckedChange={(v) => toggle(!!v)} className="mt-0.5" data-testid="client-visible-checkbox" />
      <span className="text-sm">
        <span className="font-semibold text-slate-900">Add to client walkthrough</span>
        <span className="block text-xs text-slate-600">Shares this defect with the client on the latest walkthrough, labelled “Added after walkthrough”.</span>
      </span>
    </label>
  );
};
